export default __webpack_public_path__ + "static/media/doc_view_icon.98390578.ico";